import type { AuthGap } from '../project/auth'
import { runLogin } from './commands/login'
import { section } from './output'

// The offer `deploy` makes when a project is not connected yet.
//
// Deploying is the point at which a missing login stops being an abstract fact, so this is where it is worth
// offering to fix rather than printing the name of another command. Without a terminal it stays a hard stop:
// the login needs a browser, so there is nothing to prompt for in CI.

const GAP_TEXT: Record<AuthGap, string> = {
  'not-logged-in': 'Deploying needs a connection to a Flowrunner workspace, and this project has none yet.',
  'no-workspace' : 'This project has a login but no workspace attached, so there is nowhere to deploy to.',
}

/** Passed to `deploy` as `onAuthRequired`. Throws when there is no terminal to make the offer through. */
export async function interactiveLogin(gap: AuthGap): Promise<void> {
  if (!process.stdin.isTTY) {
    // The thrown error carries the gap; `fail` turns it into the two lines the user needs.
    return
  }

  section(`  ${ GAP_TEXT[gap] }`)

  await runLogin({ confirmOpen: true })
}
